import { DocumentPickerAsset } from "expo-document-picker";
import { GET_SIGNED_UPLOAD_URL } from "./queries";
import { V3_CLIENT_NAME } from "../../components/GraphqlProvider";
import { ApolloClient } from "@apollo/client";

export const uploadFile = async (file: DocumentPickerAsset, client: ApolloClient<object>, type: string) => {
  const {
    data: { s3PostPolicy },
  } = await client.query({
    query: GET_SIGNED_UPLOAD_URL,
    context: { clientName: V3_CLIENT_NAME },
  });

  const formData = new FormData();
  formData.append("key", s3PostPolicy.fields.key);
  formData.append("X-Amz-Credential", s3PostPolicy.fields.credential);
  formData.append("X-Amz-Algorithm", s3PostPolicy.fields.algorithm);
  formData.append("X-Amz-Date", s3PostPolicy.fields.date);
  formData.append("Policy", s3PostPolicy.fields.policy);
  formData.append("X-Amz-Signature", s3PostPolicy.fields.signature);
  formData.append("X-Amz-Security-Token", s3PostPolicy.fields.securityToken);
  formData.append("file", { uri: file.uri, name: file.name, type: file.mimeType });

  await fetch(s3PostPolicy.url, {
    method: "POST",
    body: formData,
  });

  return { filename: file.name, key: s3PostPolicy.fields.key, type };
};
